import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateLanguageService } from '../../../abraj-shared/src/lib/services/translate-language.service';
import { WebsocketService } from '../../../abraj-shared/src/lib/services/websocket.service';
import { CryptoService } from '../../../abraj-shared/src/lib/services/crypto.service';
import { SessionMonitorService } from '../../../abraj-shared/src/lib/services/session-monitor.service';
import { environment } from '../environments/environment';
import { AuthorizationService } from './services/authorization-service';
import { DeviceDetectionService } from '../../../abraj-shared/src/lib/services/device-detection.service';
import { UnsupportedDeviceComponent } from '../../../abraj-shared/src/lib/components/unsupported-device/unsupported-device.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, UnsupportedDeviceComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
   private readonly router = inject(Router);
   private readonly websocketService: WebsocketService = inject(WebsocketService);
   private readonly cryptoService = inject(CryptoService);
   private readonly sessionMonitorService = inject(SessionMonitorService);
   private readonly translate = inject(TranslateService);
   public readonly languageService = inject(TranslateLanguageService);
   public readonly permissionsService = inject(AuthorizationService);
   public readonly deviceDetection = inject(DeviceDetectionService);


    ngOnInit(): void {
      this.loadTokenDataFromUrl();
      
      // Give additional time for token processing before starting session monitoring
      setTimeout(() => {
        // Start session monitoring after tokens are processed
        this.sessionMonitorService.startMonitoring();
      }, 2000);
    }

   private loadTokenDataFromUrl(): void {
  const urlParams = new URLSearchParams(window.location.search);
  const encryptedAccessToken = urlParams.get('access_token');
  const userRolesStr = urlParams.get('user_roles');
  const sessionCorrelationId = urlParams.get('sessionCorrelationId');
  const lang = urlParams.get('lang');

  if (encryptedAccessToken && userRolesStr) {
    // Decrypt the access token
    const accessToken = this.cryptoService.decrypt(encryptedAccessToken);
    
    const userRoles = JSON.parse(decodeURIComponent(userRolesStr));
    const decodedToken = JSON.parse(atob(accessToken.split('.')[1]));
    
    // Save to localStorage
    localStorage.setItem('user_name', decodedToken.given_name);
    localStorage.setItem('user_id', decodedToken.sub);
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('user_roles', JSON.stringify(userRoles));
    
    // Preserve language preference from login
    if (lang) {
      localStorage.setItem('lang', lang);
      this.translate.use(lang);
      document.documentElement.lang = lang;
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    }

      if (sessionCorrelationId !== null) {
        localStorage.setItem('sessionCorrelationId', sessionCorrelationId);
        const wsBaseUrl = environment.config.websocketUrlInfraLink;
        const wsUrl = `${wsBaseUrl}/${sessionCorrelationId}`;
        // Delegate the WebSocket connection to the service
        // this.websocketService.connect(wsUrl);
      }

      // Clear the URL parameters after processing
      this.clearUrlParameters();
  }
  this.permissionsService.fetchPermissions();

}

private clearUrlParameters(): void {
  // Get current path without query parameters
  const currentPath = window.location.pathname;
  
  // Use router to navigate to clean URL without query parameters
  this.router.navigateByUrl(currentPath, { replaceUrl: true });
}
}
